import { z } from 'zod';

export const changePasswordPostRequestSchema = z.object({
  previous_password: z.string(),
  proposed_password: z.string(),
});
